<div (mouseenter)="collapseOpenSidenav()"
  (mouseleave)="collapseCloseSidenav()"
  [class.collapsed]="collapsed"
  [class.open]="collapsed && collapsedOpen$ | async"
  class="flex flex-col sidenav">
  <div class="vex-sidenav-toolbar__container">
    <div class="flex items-center flex-none sidenav-toolbar">
      <img [src]="imageUrl$ | async" alt="Logo" class="flex-none w-6 select-none"/>
      <h2 class="flex-auto vex-sidenav-toolbar__headline">{{ title$ | async }}</h2>

    </div>

    @if (searchVisible$ | async) {
      <div class="vex-sidenav-search__container">
        <div class="relative vex-sidenav-search"
          (click)="openSearch()"
          matRipple
          matRippleColor="var(--sidenav-item-ripple-color)">
          <mat-icon class="flex-none vex-sidenav-search__icon" svgIcon="mat:search"></mat-icon>
          <div class="flex-auto vex-sidenav-search__placeholder">Rychlé vyhledávání</div>
          <div class="flex-none vex-sidenav-search__keybind">Ctrl K</div>
        </div>
      </div>
    }

    <div class="vex-sidenav-toolbar__divider"></div>
  </div>

  <vex-scrollbar class="flex flex-col flex-1">
    <div class="flex-1 pt-6">
      @for (item of items; track trackByRoute($index, item)) {
        <vex-sidenav-item
          [item]="item"
        [level]="0"></vex-sidenav-item>
      }
    </div>

    <div class="flex items-center justify-center flex-none px-6 py-6 select-none vex-sidenav-footer opacity-20">
      <img [src]="imageUrl$ | async" alt="Logo" class="w-8 select-none"/>
    </div>
  </vex-scrollbar>

  @if (userVisible$ | async) {
    <div
      class="flex-none vex-sidenav-user__container">
      <div #userProfileMenuOriginRef
        (click)="openProfileMenu(userProfileMenuOriginRef)"
        [class.vex-sidenav-user--open]="userMenuOpen$ | async"
        class="flex items-center vex-sidenav-user"
        matRipple
        matRippleColor="var(--sidenav-item-ripple-color)">
        <img alt="User Avatar" class="flex-none vex-sidenav-user__image" src="assets/img/icons/user/avatar.svg"/>
        <div class="flex-auto vex-sidenav-user__content">
          <div class="vex-sidenav-user__title">
            {{ currentUser.firstname }} {{ currentUser.lastname }}
          </div>
          <div class="vex-sidenav-user__subtitle">{{ currentUser.role.title }}</div>
        </div>
        <mat-icon class="flex-none vex-sidenav-user__dropdown-icon" svgIcon="mat:arrow_drop_down"></mat-icon>
      </div>
    </div>
  }
</div>
